"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRhumb = require("react-rhumb");

var _actions = require("settings-ui-sdk/SiteSettings/actions");

var _actions2 = require("settings-ui-sdk/DesignTemplates/actions");

var _actions3 = require("settings-ui-sdk/SitePages/actions");

var _RequestStatusTypes = require("settings-ui-sdk/constants/RequestStatusTypes");

var _selectors = require("settings-ui-sdk/SiteSettings/selectors");

var _LoadingHOC = _interopRequireDefault(require("settings-ui-lib/components/hoc/LoadingHOC"));

var BaseContentMembershipSettingsContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(BaseContentMembershipSettingsContainer, _Component);

  function BaseContentMembershipSettingsContainer() {
    (0, _classCallCheck2.default)(this, BaseContentMembershipSettingsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BaseContentMembershipSettingsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(BaseContentMembershipSettingsContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.loadSiteSettings();
      this.props.loadMembershipTemplates();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fetchSiteSettingsRequestStatus = _this$props.fetchSiteSettingsRequestStatus,
          children = _this$props.children;
      return _react.default.createElement(_LoadingHOC.default, {
        unrecoverableFailure: true,
        requestStatuses: [fetchSiteSettingsRequestStatus],
        successMarker: _react.default.createElement(_reactRhumb.NavMarker, {
          name: "CONTENT_MEMBERSHIP_LOADED"
        }),
        failureMarker: _react.default.createElement(_reactRhumb.NavMarker, {
          name: "CONTENT_MEMBERSHIP_LOADED_FAILURE"
        })
      }, children);
    }
  }]);
  return BaseContentMembershipSettingsContainer;
}(_react.Component);

BaseContentMembershipSettingsContainer.propTypes = {
  children: _react.PropTypes.node,
  loadSiteSettings: _react.PropTypes.func.isRequired,
  loadMembershipTemplates: _react.PropTypes.func.isRequired,
  fetchSiteSettingsRequestStatus: _RequestStatusTypes.RequestStatusPropType.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    fetchSiteSettingsRequestStatus: (0, _selectors.getFetchSiteSettingsRequestStatus)(state)
  };
};

var mapDispatchToProps = {
  loadSiteSettings: _actions.loadSiteSettings,
  loadMembershipTemplates: _actions2.loadMembershipTemplates,
  fetchPublishedSitePages: _actions3.fetchPublishedSitePages
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BaseContentMembershipSettingsContainer);

exports.default = _default;
module.exports = exports.default;